export default __webpack_public_path__ + "static/media/sort_up.2b2bb350.svg";